export default __webpack_public_path__ + "static/media/sausages.85e5fbcc.webp";